import { AmenityFormLayout } from '@/components/amenities';
import { useAmenityForm } from '@/hooks/useAmenityForm';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Hotel-scoped create-amenity form at `/hotels/:id/amenities/new`. Renders the
 * same single-page {@link AmenityFormLayout} (top bar + centered form) as the
 * global amenity form, but pre-targets the hotel and returns to the hotel's
 * Amenities tab on both cancel and a successful create.
 */
export function HotelAmenityFormPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const backToAmenities = () => navigate(`/hotels/${id}/amenities`);

  const { formData, setFormData, isSaving, lastSaved, handleSubmit } = useAmenityForm({
    hotelId: id,
    onSuccess: backToAmenities,
  });

  if (!id) return null;

  return (
    <AmenityFormLayout
      title="Create Amenity"
      submitLabel="Create Amenity"
      isSaving={isSaving}
      lastSaved={lastSaved}
      onCancel={backToAmenities}
      onSubmit={handleSubmit}
      formData={formData}
      setFormData={setFormData}
    />
  );
}
